import React from 'react';
import { Users, FolderOpen, FileText, Clock } from 'lucide-react';
import { motion } from 'framer-motion';

export default function QuickStats({ stats }) {
  const quickStats = [
    {
      label: 'Total Pegawai',
      value: stats.employees,
      icon: Users,
      color: 'text-emerald-600 bg-emerald-50',
    },
    {
      label: 'Total Debitur',
      value: stats.debtors,
      icon: FolderOpen,
      color: 'text-amber-600 bg-amber-50',
    },
    {
      label: 'Aplikasi Kredit',
      value: stats.creditApplications,
      icon: FileText,
      color: 'text-blue-600 bg-blue-50',
    },
    {
      label: 'Pending Approval',
      value: stats.pendingApprovals,
      icon: Clock,
      color: 'text-red-600 bg-red-50',
    },
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4">
      {quickStats.map((stat, index) => (
        <motion.div
          key={stat.label}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: index * 0.1 }}
        >
          <div className="bg-white rounded-lg border shadow-sm hover:shadow-md transition-shadow p-4">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-500">{stat.label}</p>
                <p className="text-3xl font-bold mt-1">{stat.value}</p>
              </div>
              <div
                className={`w-12 h-12 rounded-xl flex items-center justify-center ${stat.color}`}
              >
                <stat.icon className="w-6 h-6" />
              </div>
            </div>
          </div>
        </motion.div>
      ))}
    </div>
  );
}
